import { render } from "./WenAnAiCrateView.vue?vue&type=template&id=799213ec"
import script from "./WenAnAiCrateView.vue?vue&type=script&lang=js"
export * from "./WenAnAiCrateView.vue?vue&type=script&lang=js"

import "./WenAnAiCrateView.vue?vue&type=style&index=0&id=799213ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__